import { Radio, Stack, Text, textColors, textVariants, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { price as priceUtils } from '@eti/utils';
import { Tier } from '@eti/schema-types';
import { getPriceDivided as getPricePerTraveler } from '../../../common/utils/price';
import { stylesVariables } from '../../utils/utils';
import { screenReaderOnly } from '../../../common/utils/styles';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const {
  colors: {
    divider: BorderColor
  }
} = vars;
const {
  recommendedBackground
} = stylesVariables;
const optionStyles = isRecommended => css`
  ${isRecommended ? `background-color: ${recommendedBackground}` : ''};
  border-left: 1px solid ${BorderColor};
  display: flex;
  flex: 1;
  padding: 8px;
  padding-bottom: 16px;

  html[dir='rtl'] & {
    border-left: unset;
    border-right: 1px solid ${BorderColor};
  }
`;
const lineStrikeStyle = css`
  text-decoration: line-through;
`;
const SelectionOption = _ref => {
  let {
    name,
    numberOfTravelers,
    option,
    priceText,
    shouldShowPricePerPerson
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    formatPrice
  } = priceUtils;
  const {
    id,
    originalPrice,
    priceRaw,
    title,
    type,
    features
  } = option;
  const formattedOriginalPrice = shouldShowPricePerPerson ? formatPrice(getPricePerTraveler(originalPrice, numberOfTravelers)) : formatPrice(originalPrice);
  const formattedDiscountPrice = shouldShowPricePerPerson ? formatPrice(getPricePerTraveler(priceRaw, numberOfTravelers)) : formatPrice(priceRaw);
  const includedProducts = features === null || features === void 0 ? void 0 : features.map(feature => `${feature.name}`).join(', ');
  const isRecommended = type === Tier.Recommended;
  return /*#__PURE__*/_jsxs(Stack, {
    align: "center",
    className: optionStyles(isRecommended),
    spacing: 4,
    children: [/*#__PURE__*/_jsxs(Stack, {
      align: "center",
      id: `option-${id}-content`,
      spacing: 4,
      style: {
        textAlign: 'center'
      },
      children: [isRecommended && /*#__PURE__*/_jsxs("span", {
        "aria-live": "polite",
        className: screenReaderOnly,
        children: [t('Product.Bundle.Recommended.Text'), "."]
      }), originalPrice > 0 && /*#__PURE__*/_jsxs(Text, {
        as: "p",
        className: lineStrikeStyle,
        color: textColors.SECONDARY,
        children: [/*#__PURE__*/_jsx("span", {
          className: screenReaderOnly,
          children: `${t('ScreenReader.Product.Bundle.Original.Price.Text')}:
              ${priceUtils.replaceWithCurrencyName(formattedOriginalPrice)}`
        }), /*#__PURE__*/_jsx("span", {
          "aria-hidden": "true",
          children: formattedOriginalPrice
        })]
      }), /*#__PURE__*/_jsxs(Text, {
        as: "p",
        variant: textVariants._18_EMPHASIZED,
        children: [/*#__PURE__*/_jsx("span", {
          className: screenReaderOnly,
          children: `${t('ScreenReader.Product.Bundle.Discounted.Price.Text')}:
            ${priceUtils.replaceWithCurrencyName(formattedDiscountPrice)}`
        }), /*#__PURE__*/_jsx("span", {
          "aria-hidden": "true",
          children: formattedDiscountPrice
        })]
      }), /*#__PURE__*/_jsx("span", {
        "aria-live": "polite",
        className: screenReaderOnly,
        children: `${features === null || features === void 0 ? void 0 : features.length} ${t('ScreenReader.Product.Bundle.Included.Text')}: ${includedProducts}`
      }), /*#__PURE__*/_jsx(Text, {
        children: priceText
      })]
    }), /*#__PURE__*/_jsx(Radio, {
      "aria-describedby": `option-${id}-content`,
      id: `choice.${name}.${id}`,
      value: id
    }), /*#__PURE__*/_jsx(Radio.Label, {
      "data-testid": `productBundleItem-${id}`,
      htmlFor: `choice.${name}.${id}`,
      children: title
    })]
  });
};
export default SelectionOption;
//# sourceMappingURL=SelectionOption.js.map